import { z } from 'zod'
import { oc } from '@orpc/contract'
import {
  soapNoteDraftSchema,
  soapNoteSchema,
  visitContextSchema,
} from '../soap-note-payload.contract'

export const createSoapNoteResponseSchema = z.object({
  documentReferenceId: z.string(),
  encounterId: z.string(),
  questionnaireResponseId: z.string().optional(),
  provenanceId: z.string().optional(),
})
export type CreateSoapNoteResponse = z.infer<typeof createSoapNoteResponseSchema>

const soapNoteBody = z.object({
  soapNote: soapNoteSchema,
  visitContext: visitContextSchema,
})

// Chart-level submit — mints a fresh Encounter + Progress Note (no encounterId).
export const visitSubmitSoapNote = oc
  .route({ method: 'POST', path: '/v2/visits/soap-note' })
  .input(soapNoteBody)
  .output(createSoapNoteResponseSchema)

// Draft save for an existing encounter (call-page in-progress note).
export const visitSaveSoapNoteDraft = oc
  .route({ method: 'POST', path: '/v2/visits/{encounterId}/soap-note' })
  .input(
    soapNoteBody.extend({
      encounterId: z.string(),
      soapNote: soapNoteDraftSchema,
      // The note being edited, once it exists (PD-2031): a save to a note removed from the
      // chart is refused instead of filed as a new draft. Optional for older clients.
      documentReferenceId: z.string().optional(),
    }),
  )
  .output(createSoapNoteResponseSchema)
